import styled from 'styled-components';
import {
  Dialog,
  mediaHelper,
  paletteHelper,
  radiusHelper,
  spacingHelper,
} from '@property.com.au/ui-kit';
import { modalCloseButton } from '../../app-kit/helpers/modalCloseButton';

export const ModalDialog = styled(Dialog)`
  border-radius: ${radiusHelper('extraLarge')};

  .header {
    background: ${paletteHelper('backgroundPrimaryBase')};
    padding: ${spacingHelper('large large large large')};
    border-bottom: none;
  }

  .footer {
    padding: ${spacingHelper('large')};
  }

  .closeButton {
    ${modalCloseButton};
    top: ${spacingHelper('extraSmall')};
    right: ${spacingHelper('extraSmall')};
  }

  .body {
    padding-top: 0;
    > div {
      min-height: 100%;
    }
  }

  ${mediaHelper('tabletMin')} {
    max-width: calc(${spacingHelper('threeExtraLarge')} * 8 + ${spacingHelper('extraLarge')});

    .body {
      height: 100vh;
      max-height: calc(
        ${spacingHelper('threeExtraLarge')} * 13 + ${spacingHelper('twoExtraLarge')}
      );
    }
  }
`;
